import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const Category_View = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const fetchCategory = async () => {
            try {
                const res = await authManager.authenticatedFetch(`${Base_Url}/shopping/categories/${id}`);
                if (!res.ok) throw new Error("Fetch failed");
                const data = await res.json();
                setCategory(data.result);
            } catch (err) {
                console.error("Failed to load category:", err);
                navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        fetchCategory();
    }, [id, navigate]);

    if (!loading && !category) {
        return <div className="text-center mt-5">Category not found.</div>;
    }

    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6">
                            <h1 className="m-0 txt_lft">View Category</h1>
                        </div>
                        <div className="col-6 text-right">
                            <Link to="/category" className="btn btn-link">
                                <i className="fa-solid fa-arrow-left-long" /> Back
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    {loading ? (
                                        <div className="card-body text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="card-body">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Category</label>
                                                <div className="col-md-8">
                                                    <div className="mb-2 w-100"><label>Name:</label> {category.name || '-'}</div>
                                                    <div className="w-100"><label>Keywords:</label> {(category.keywords || []).join(', ') || '-'}</div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-12 col-md-4 col-form-label">Sub Categories</label>
                                                <div className="col-12 col-md-8">
                                                    {(category.children || []).length === 0 ? (
                                                        <div>No subcategories available.</div>
                                                    ) : (
                                                        category.children.map((sub, index) => (
                                                            <div key={sub._id || index} className="subcategory_div mt-2 mb-4">
                                                                <div className="subcategory_div1 mt-2">
                                                                    <h6 className="f_sz14 mb-3 f_blue fwt_600">Sub Category:</h6>
                                                                    <div className="mb-2 w-100"><label>Name:</label> {sub.name || '-'}</div>
                                                                    <div className="w-100"><label>Keywords:</label> {(sub.keywords || []).join(', ') || '-'}</div>

                                                                    {sub.children && sub.children.length > 0 && (
                                                                        <div className="view_childcat mt-2">
                                                                            <h6 className="f_sz14 mt-3 f_blue fwt_600">Child Category:</h6>
                                                                            {sub.children.map((child, childIndex) => (
                                                                                <div key={child._id || childIndex} className="view_childcat_listitem my-3 pb-2">
                                                                                    <div className="mb-2 w-100"><label>Name:</label> {child.name || '-'}</div>
                                                                                    <div className="w-100"><label>Keywords:</label> {(child.keywords || []).join(', ') || '-'}</div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="card-footer text-center">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Category_View;
